/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Fuzzy_Hound_ApproveInputs */

const fr_soft_fuzzy_hound_approve = /** @type {(inputs: Soft_Fuzzy_Hound_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

/**

* @param {Soft_Fuzzy_Hound_ApproveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const soft_fuzzy_hound_approve = /** @type {((inputs?: Soft_Fuzzy_Hound_ApproveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Fuzzy_Hound_ApproveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_soft_fuzzy_hound_approve(inputs)
});